export default "__VITE_ASSET__DQBkYn26__"